import React, { useEffect, useRef, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../../Base/Components/Card/Card";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";


import { getTerms } from "../../../../API/Compras/Terms/TermsRequest";
import TermsCrudModal from "./TermsCRUD/TermsCrudModal";
// import EstantesCrudModal from "./EstantesCRUD/EstantesCrudModal";

const TermScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getTerms();
    // console.log(d);
    setTerm(d);
    setLoading(false);
  };


  const columns = [
    {
      header: "ID",
      field: "IdTerm",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Nombre",
      headerEn: "Name",
      field: "Term",
      Sumary: "count",
      
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "TermDescription",
    },
    {
      header: "Tipo",
      headerEn: "Type",
      field: "Type",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",     
      filter: false, 
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      header: "TermValue",
      field: "TermValue",
    },
    {
      header: "User Edit",
      headerEn: "User Edit",
      field: "Usuario",
      flex: 1,
    },
    {
      header: "Fecha Creación",
      headerEn: "Date Create",
      field: "DateCreate",
      Format:"DateTime"
    },
    {
      field: "IdTerm",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: term,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "termino", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "termino", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <TermsCrudModal
          toastRef={toast}
          termsDialog={showDialog}
          term={selected}
          setTermsDialog={setShowDialog}
          getTerm={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default TermScreen;
